import {Component, OnInit} from '@angular/core';
import {Platform} from '@angular/cdk/platform';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-remittance',
  templateUrl: './remittance.component.html',
  styleUrls: ['./remittance.component.scss']
})
export class RemittanceComponent implements OnInit {
  productName = environment.programNameRemittance;
  androidStoreURL: string = environment.remittanceAndroidStore;
  iosStoreURL: string = environment.remittanceIosStore;
  referredCodeParam: string;

  namespace = environment.namespace;
  url = environment.homeEndpoint.slice(8);

  constructor(public platform: Platform) {
  }

  ngOnInit(): void {
    if (this.platform.IOS) {
      window.location.href = this.iosStoreURL;
    }
    if (this.platform.ANDROID) {
      window.location.href = this.androidStoreURL;
    }
  }

}